import React, { useState, useEffect, useMemo } from "react";
import { ToastContainer, Flip } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import {
  Box,
  Divider,
  FormControl,
  FormControlLabel,
  Modal,
  Radio,
  RadioGroup,
} from "@mui/material";
import Loader from "../../Shared_Components/Loader";
import { RiSave2Fill } from "react-icons/ri";
import { BsCheck2 } from "react-icons/bs";
import { TbArrowBackUp } from "react-icons/tb";
import { FaUndo } from "react-icons/fa";
import { IoMdAdd } from "react-icons/io";
import { ImExit } from "react-icons/im";
import { useNavigate, useSearchParams } from "react-router-dom";
import { API_HOST } from "../../api_utils";
import axios from "axios";

function TransactionList(props) {
  const { userDataFromStorage } = props;
  let navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const loanHeaderIdFromParams = searchParams.get("loanHeader");
  const [transactionList, setTransactionList] = useState([]);
  const [loanHeaderList, setLoanHeaderList] = useState([]);
  const [customerList, setCustomerList] = useState([]);
  const [loanProductList, setLoanProductList] = useState([]);
  const [userList, setUserList] = useState([]);
  const [currentLoanHeader, setCurrentLoanHeader] = useState({});
  const [currentLoanProduct, setCurrentLoanProduct] = useState({});
  const [currentCustomer, setCurrentCustomer] = useState({});
  const [agentAssignedToCustomer, setAgentAssignedToCustomer] = useState({});
  const [transactionSuccess, setTransactionSuccess] = useState(false);
  const [showEditPayment, setShowEditPayment] = useState(false);
  const [transactionEditDetail, setTransactionEditDetail] = useState({});
  const [formattedTransactionDate, setFormattedTransactionDate] = useState("");
  const [transactionEditSuccess, setTransactionEditSuccess] = useState(false);

  // AddtransactionPayload states:
  const [addTransactionPayload, setAddTransactionPayload] = useState({
    transaction_date: "",
    transaction_amount: "",
    none_collection_days: "",
    loan_header_ref: "",
  });

  const getTransactionList = async () => {
    setLoading(true);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage?.token}`,
      },
    };

    const { data } = await axios.get(
      `${API_HOST}/api/transactions/${loanHeaderIdFromParams}`,
      config
    );

    if (data.message) {
      setLoading(false);
      toast.warn(data.message);
    } else {
      setLoading(false);
      setTransactionList(data);
    }
  };

  const getLoanHeaderList = async () => {
    setLoading(true);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage?.token}`,
      },
    };
    const { data } = await axios.get(
      `${API_HOST}/api/loan_header/loan_detail_admin/${loanHeaderIdFromParams}`,
      config
    );

    if (data.message) {
      setLoading(false);
      toast.error(data.message);
    } else {
      setLoading(false);
      console.log("data", data[0]);
      setLoanHeaderList(data[0]);
    }
  };

  // const getLoanProductList = async () => {
  //   setLoading(true)
  //   const config = {
  //     headers: {
  //       'Content-Type': 'application/json',
  //     }
  //   }
  //   const { data } = await axios.get(`${API_HOST}/api/loanproducts/get_loan_products/`, config)

  //   if (data.message) {
  //     setLoading(false)
  //     toast.error(data.message)
  //   } else {
  //     setLoading(false)
  //     setLoanProductList(data)
  //   }
  // }

  // const getCustomerList = async () => {
  //   setLoading(true)
  //   const config = {
  //     headers: {
  //       'Content-Type': 'application/json',
  //       'Authorization': `Bearer ${userDataFromStorage?.token}`
  //     }
  //   }
  //   const { data } = await axios.get(`${API_HOST}/api/customer/`, config)

  //   if (data.message) {
  //     setLoading(false)
  //     toast.error(data.message)
  //   } else {
  //     setLoading(false)
  //     setCustomerList(data)
  //   }
  // }

  // const getUserList = async () => {
  //   setLoading(true)
  //   const config = {
  //     headers: {
  //       'Content-Type': 'application/json',
  //       'Authorization': `Bearer ${userDataFromStorage?.token}`
  //     }
  //   }
  //   const { data } = await axios.get(`${API_HOST}/api/users/`, config)

  //   if (data.message) {
  //     setLoading(false)
  //     toast.error(data.message)
  //   } else {
  //     setLoading(false)
  //     setUserList(data)
  //   }
  // }

  useEffect(() => {
    getTransactionList();
    getLoanHeaderList();
  }, [transactionSuccess, transactionEditSuccess]);

  // useEffect(() => {
  //   if (loanHeaderList.length && loanProductList.length && customerList.length && userList.length) {
  //     const filterLoanHeader = loanHeaderList.find((x) => x._id === loanHeaderIdFromParams);
  //     const filteredLoanProduct = loanProductList.find((y) => y.id_number === filterLoanHeader?.loan_product_ref);
  //     const filteredCustomer = customerList.find((z) => z.id_number === filterLoanHeader?.customer_ref);
  //     const filteredAgent = userList.find((a) => a.employee_number === filteredCustomer?.agent)
  //     if (filterLoanHeader && filteredLoanProduct && filteredCustomer && filteredAgent) {
  //       setCurrentLoanHeader(filterLoanHeader);
  //       setCurrentCustomer(filteredCustomer);
  //       setCurrentLoanProduct(filteredLoanProduct)
  //       setAgentAssignedToCustomer(filteredAgent)
  //     }
  //   }
  // }, [loanHeaderList, loanProductList, customerList, loanHeaderIdFromParams, userList])

  // add transaction:
  const addTransactionHandler = async () => {
    if (
      addTransactionPayload.transaction_amount &&
      addTransactionPayload.transaction_date &&
      addTransactionPayload.none_collection_days
    ) {
      setLoading(true);
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userDataFromStorage?.token}`,
        },
      };

      const newPayload = {
        none_collection_days: parseInt(
          addTransactionPayload.none_collection_days
        ),
        transaction_amount: parseInt(addTransactionPayload.transaction_amount),
        transaction_date: addTransactionPayload.transaction_date,
        loan_header_ref: currentLoanHeader._id,
      };
      const { data } = await axios.post(
        `${API_HOST}/api/transactions/add_transaction`,
        newPayload,
        config
      );

      if (data.message) {
        setLoading(false);
        toast.error(data.message);
      } else {
        setLoading(false);
        toast.success("New Transaction DEtails Added Successfully !!!");
        setOpen(false);
        setTransactionSuccess(true);
      }
    } else {
      toast.warn("Make Sure To Fill All Fields !!!");
    }
  };

  // convert date into dd-mm-yyyy format :
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const year = String(date.getUTCFullYear());
    return `${day}-${month}-${year}`;
  };

  // Use `useMemo` to call the function once and memoize the result
  const formattedData = useMemo(() => {
    return transactionList.map((x) => ({
      ...x,
      transaction_date_formatted: formatDate(x.transaction_date),
      current_next_req_txn_date_formatted: formatDate(
        x.current_next_req_txn_date
      ),
    }));
  }, [transactionList]);

  const editTransactionHander = async (reason) => {
    setLoading(true);
    console.log("reason", reason);
    if (reason === "edit") {
      setTransactionEditSuccess(false);
      const config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${userDataFromStorage.token}`,
        },
      };

      transactionEditDetail.reason = "edit";

      console.log("res 1", transactionEditDetail);
      const { data } = await axios.post(
        `${API_HOST}/api/transactions/edit_transaction_amount`,
        transactionEditDetail,
        config
      );

      if (data && data.message === "Transaction Edited Successfully!!!") {
        setLoading(false);
        setShowEditPayment(false);
        setTransactionEditSuccess(true);
        toast.success("Payment Detail Edited Successfully !!!");
      }
    }
  };

  return (
    <div
      className={
        userDataFromStorage.user_role === "admin"
          ? "xl:px-[10rem] lg:px-[6rem] md:px-[3.5rem] px-[2rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[15%]  xl:mt-[9%] mt-[20%] bg-blue-50  overflow-hidden"
          : "xl:px-[10rem] lg:px-[6rem] md:px-[3.5rem] px-[2rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[10%]  xl:mt-[5%] mt-[20%] bg-blue-50 overflow-hidden"
      }>
      <p className="text-gray-800 text-[1.8rem] tracking-wider">
        Transaction List
      </p>
      <div className="bg-white md:text-[0.75rem] lg:text-[1rem]">
        <p
          id="customer"
          className="change-bg text-white px-[0.5rem] py-[1rem] mt-6">
          Customer and Loan Details
        </p>
        <div className="md:px-[0.5rem] px-[0.7rem]">
          <div className="md:flex justify-start items-center border-b md:h-[4rem] mt-2 md:mt-0">
            <div className="flex justify-between md:w-[50%] items-center  md:border-r-[2rem] h-[100%]  border-[#f9ddc2]">
              <p>Customer Nickname</p>
              <p className="md:w-[50%] text-center">
                {loanHeaderList ? loanHeaderList.customer_nickname : "---"}
              </p>
            </div>
            <div className="flex justify-between md:w-[50%] md:pl-[0.5rem] items-center  h-[100%] ">
              <p>Total Due</p>
              <p className="md:w-[50%] text-center">
                MYR {loanHeaderList ? loanHeaderList.total_due : "---"}
              </p>
            </div>
          </div>
          <div className="md:flex justify-start items-center border-b md:h-[4rem] mt-2 md:mt-0">
            <div className="flex justify-between md:w-[50%] items-center  md:border-r-[2rem] h-[100%]  border-[#f9ddc2]">
              <p>Agent Name</p>
              <p className="md:w-[50%] text-center">
                {loanHeaderList ? loanHeaderList.agentName : "---"}
              </p>
            </div>
            <div className="flex md:pl-[0.5rem] justify-between md:w-[50%] items-center   h-[100%]  ">
              <p>Deducted at Loan Start</p>
              <p className="md:w-[50%] text-center">
                {loanHeaderList.initial_days_deducted !== null &&
                loanHeaderList.product_code !== null
                  ? `MYR ${
                      loanHeaderList.initial_days_deducted *
                      Number(loanHeaderList?.product_code?.split("-")[1])
                    }`
                  : "---"}
              </p>
            </div>
          </div>
          <div className="md:flex justify-start items-center border-b md:h-[4rem] mt-2 md:mt-0">
            <div className="flex justify-between md:w-[50%] items-center  md:border-r-[2rem] h-[100%]  border-[#f9ddc2]">
              <p>Product Code</p>
              <p className="md:w-[50%] text-center">
                {loanHeaderList.product_code !== null
                  ? ` ${loanHeaderList.product_code}`
                  : "---"}
              </p>
            </div>
            <div className="flex justify-between md:w-[50%] items-center   h-[100%] md:pl-[0.5rem]">
              <p>Total Amount Paid</p>
              <p className="md:w-[50%] text-center">
                {loanHeaderList.amount_paid !== null
                  ? `MYR ${loanHeaderList.amount_paid}`
                  : "---"}
              </p>
            </div>
          </div>
          <div className="md:flex justify-start items-center border-b md:h-[4rem] mt-2 md:mt-0">
            <div className="flex justify-between md:w-[50%] items-center  md:border-r-[2rem] h-[100%]  border-[#f9ddc2]">
              <p>Loan Amount</p>
              <p className="md:w-[50%] text-center">
                {loanHeaderList ? `MYR ${loanHeaderList.amount}` : "---"}
              </p>
            </div>
            <div className="flex justify-between md:w-[50%] items-center   h-[100%] md:pl-[0.5rem]">
              <p>Total Amount Remaining</p>
              <p className="md:w-[50%] text-center">
                {`MYR ${loanHeaderList.amount_remaining}`}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white md:text-[0.75rem] lg:text-[1rem]">
        <p
          id="transaction"
          className="change-bg text-white px-[0.5rem] py-[1rem] mt-6">
          Transaction Details
        </p>
        <div className="overflow-scroll px-[0.5rem]">
          <table className="md:w-[100%] xl:w-[100%] w-[300%] ">
            <thead className="h-[6vh]">
              <tr>
                <th className="text-start border-l border-t border-r border-gray-400 px-[0.2rem]">
                  Transaction Number
                </th>
                <th className="text-start border-r border-t border-gray-400 px-[0.2rem]">
                  Transaction Date
                </th>
                <th className="text-start border-r border-t border-gray-400 px-[0.2rem]">
                  Transaction Amount
                </th>
                <th className="text-start border-r border-t border-gray-400 px-[0.2rem]">
                  Current Next Req Txn Date
                </th>
                <th className="text-start border-r border-t border-gray-400 px-[0.2rem]"></th>
              </tr>
            </thead>
            <tbody>
              {formattedData.length
                ? formattedData.map((x, index) => {
                    const inputDate = new Date(x?.transaction_date);

                    const months = [
                      "January",
                      "February",
                      "March",
                      "April",
                      "May",
                      "June",
                      "July",
                      "August",
                      "September",
                      "October",
                      "November",
                      "December",
                    ];

                    console.log("input date", inputDate);

                    const day = inputDate.getDate();
                    console.log("day::::", day);
                    const month = months[inputDate.getMonth()];
                    const year = inputDate.getFullYear();

                    const formattedDate = `${day} ${month}, ${year}`;

                    return (
                      <tr key={index}>
                        <td
                          className={
                            index === formattedData.length - 1
                              ? "text-start border-l border-t border-r border-b border-gray-400 px-[0.2rem]"
                              : "text-start border-l border-t border-r border-gray-400 px-[0.2rem]"
                          }>
                          {x.transaction_number}
                        </td>
                        <td
                          className={
                            index === formattedData.length - 1
                              ? "text-start border-t border-r border-gray-400 px-[0.2rem] border-b"
                              : "text-start border-t border-r border-gray-400 px-[0.2rem]"
                          }>
                          {formattedDate}
                        </td>
                        <td
                          className={
                            index === formattedData.length - 1
                              ? "text-start border-t border-r border-gray-400 px-[0.2rem] border-b"
                              : "text-start border-t border-r border-gray-400 px-[0.2rem]"
                          }>
                          MYR {x.transaction_amount}
                        </td>
                        <td
                          className={
                            index === formattedData.length - 1
                              ? "text-start border-t border-r border-gray-400 px-[0.2rem] border-b"
                              : "text-start border-t border-r border-gray-400 px-[0.2rem]"
                          }>
                          {x.current_next_req_txn_date_formatted}
                        </td>
                        {userDataFromStorage.user_role === "admin" ||
                        userDataFromStorage.user_role === "manager" ? (
                          <td
                            className={
                              index === formattedData.length - 1
                                ? "text-start border-t border-r border-gray-400 px-[0.2rem] border-b py-[0.5rem]"
                                : "text-start border-t border-r border-gray-400 px-[0.2rem] py-[0.5rem]"
                            }>
                            <button
                              onClick={() => {
                                setTransactionEditDetail(x);
                                setShowEditPayment(true);
                                setFormattedTransactionDate(formattedDate);
                              }}
                              className="px-6 py-2 rounded-lg bg-green-500 hover:bg-green-100 text-white hover:text-green-500 transition duration-[0.3s]">
                              Edit Transaction
                            </button>
                          </td>
                        ) : (
                          ""
                        )}
                      </tr>
                    );
                  })
                : ""}
            </tbody>
          </table>
        </div>
      </div>

      <div className="flex justify-start items-center space-x-3 mt-[2rem]">
        {userDataFromStorage.user_role === "admin" ||
        userDataFromStorage.user_role === "manager" ? (
          <button
            id="newTransaction"
            onClick={() => setOpen(true)}
            className="flex justify-center items-center space-x-2  text-orange-50 px-[1rem] py-[0.5rem] rounded change-bg hover:bg-orange-50 transition duration-[0.6s] hover:shadow-2xl hover:shadow-black">
            <IoMdAdd />
            <p>New Transaction</p>
          </button>
        ) : (
          ""
        )}
        <button
          id="reset"
          onClick={() => navigate("/loans")}
          className="flex justify-center items-center space-x-2 change-bg text-green-50 px-[1rem] py-[0.5rem] rounded  hover:bg-green-50 transition duration-[0.6s] hover:shadow-2xl hover:shadow-black">
          <FaUndo />
          <p>Close</p>
        </button>
        <button
          id="exit1"
          onClick={() => navigate("/home")}
          className="flex justify-center items-center space-x-2  text-purple-50 px-[1rem] py-[0.5rem] rounded change-bg hover:bg-purple-50 transition duration-[0.6s] hover:shadow-2xl hover:shadow-black">
          <ImExit />
          <p>Exit</p>
        </button>
      </div>

      <Modal
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
        className="flex justify-center items-center overflow-y-scroll mb-[0.5rem]">
        <Box className="md:w-[50%] w-[95%]  rounded-lg bg-white absolute top-[8%] mb-[10rem] ">
          {loading ? (
            <Loader />
          ) : (
            <>
              <div className="p-[0.5rem]">
                <p className="text-lg text-gray-800">New Payment Collection</p>
              </div>
              <Divider />

              <div className="p-[0.5rem]">
                {/* Transaction date (Required) */}
                <div className="grid grid-cols-6 m-[0.3em]">
                  <label
                    htmlFor="date"
                    className="flex justify-start items-center col-span-2 space-x-1">
                    <span className="text-gray-700">Transaction Date</span>
                    <span className="text-red-600 text-lg">*</span>
                  </label>
                  <input
                    onChange={(e) =>
                      setAddTransactionPayload((prevState) => ({
                        ...prevState,
                        transaction_date: e.target.value,
                      }))
                    }
                    value={addTransactionPayload.transaction_date}
                    type="date"
                    id="date"
                    className="p-[0.5rem] border border-gray-500 rounded-lg flex-1 outline-none col-span-4"
                    placeholder="Enter A Transaction Date"
                  />
                </div>

                <div className="grid grid-cols-6 m-[0.3em]">
                  <label
                    htmlFor="amt-outstanding"
                    className="flex justify-start items-center col-span-2 space-x-1">
                    <span className="text-gray-700">Amount Outstanding</span>
                  </label>
                  <p className="col-span-4">
                    {loanHeaderList.amount_remaining !== null
                      ? `MYR ${loanHeaderList.amount_remaining}`
                      : "---"}
                  </p>
                </div>

                <div className="grid grid-cols-6 m-[0.3em]">
                  <label
                    htmlFor="std-pay-amt"
                    className="flex justify-start items-center col-span-2 space-x-1">
                    <span className="text-gray-700">
                      Standard Payment Amount
                    </span>
                  </label>
                  <p className="col-span-4">
                    {loanHeaderList
                      ? `MYR ${loanHeaderList.collection_amount}`
                      : "---"}
                  </p>
                </div>

                <div className="grid grid-cols-6 m-[0.3em]">
                  <label
                    htmlFor="trac-amt"
                    className="flex justify-start items-center col-span-2 space-x-1">
                    <span className="text-gray-700">Transaction Amount</span>
                    <span className="text-red-600 text-lg">*</span>
                  </label>
                  <input
                    onChange={(e) =>
                      setAddTransactionPayload((prevState) => ({
                        ...prevState,
                        transaction_amount: e.target.value,
                      }))
                    }
                    value={addTransactionPayload.transaction_amount}
                    type="number"
                    id="trac-amt"
                    className="p-[0.5rem] border border-gray-500 rounded-lg flex-1 outline-none col-span-4"
                    placeholder="Enter A Transaction Amount"
                  />
                </div>

                <div className="grid grid-cols-6 m-[0.3em]">
                  <label
                    htmlFor="new-colle-days"
                    className="flex justify-start items-center col-span-2 space-x-1">
                    <span className="text-gray-700">None Collection Days</span>
                    <span className="text-red-600 text-lg">*</span>
                  </label>
                  <div className="col-span-4 flex flex-col justify-center items-start ">
                    <input
                      onChange={(e) =>
                        setAddTransactionPayload((prevState) => ({
                          ...prevState,
                          none_collection_days: e.target.value,
                        }))
                      }
                      value={addTransactionPayload.none_collection_days}
                      type="number"
                      id="new-colle-days"
                      className="p-[0.5rem] border border-gray-500 rounded-lg flex-1 outline-none w-[100%]"
                      placeholder="Enter None Collection Days"
                    />
                    <small className="text-[0.9rem] text-gray-600 font-[600] opacity-50">
                      Customer or Agent away, for these number of days
                    </small>
                  </div>
                </div>

                <div className="flex justify-end items-center space-x-4 mt-8 mb-4">
                  <button
                    onClick={() => setOpen(false)}
                    className="flex justify-center items-center space-x-2 bg-purple-400 text-purple-50 px-[1rem] py-[0.5rem] rounded hover:text-purple-500 hover:bg-purple-50 transition duration-[0.6s] hover:shadow-2xl hover:shadow-black">
                    <TbArrowBackUp />
                    <p>Cancel</p>
                  </button>
                  <button
                    onClick={() => addTransactionHandler()}
                    className="flex justify-center items-center space-x-2 bg-green-400 text-green-50 px-[1rem] py-[0.5rem] rounded hover:text-green-500 hover:bg-green-50 transition duration-[0.6s] hover:shadow-2xl hover:shadow-black ">
                    <RiSave2Fill />
                    <p>Save</p>
                  </button>
                </div>
              </div>
            </>
          )}
        </Box>
      </Modal>

      <Modal
        open={showEditPayment}
        onClose={() => setShowEditPayment(false)}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
        className="flex justify-center items-center overflow-y-scroll mb-[0.5rem]">
        <Box className="md:w-[50%] w-[95%] rounded-lg bg-white absolute top-[8%] mb-[10rem] ">
          {loading ? (
            <Loader />
          ) : (
            <>
              <div className="p-[0.5rem]">
                <p className="text-lg text-gray-800">Edit Payment Detail</p>
              </div>
              <Divider />

              <div className="p-[0.5rem]">
                {/* Transaction date (Required) */}
                <div className="grid grid-cols-6 m-[0.3em]">
                  <label
                    htmlFor="date"
                    className="flex justify-start items-center col-span-2 space-x-1">
                    <span className="text-gray-700">Transaction Number</span>
                  </label>
                  <input
                    value={transactionEditDetail.transaction_number}
                    type="text"
                    id="text"
                    className="p-[0.5rem] border border-gray-500 rounded-lg flex-1 outline-none col-span-4"
                    placeholder="Enter A Transaction Date"
                    disabled={true}
                  />
                </div>

                <div className="grid grid-cols-6 m-[0.3em]">
                  <label
                    htmlFor="date"
                    className="flex justify-start items-center col-span-2 space-x-1">
                    <span className="text-gray-700">Transaction Date</span>
                  </label>
                  <input
                    value={formattedTransactionDate}
                    type="text"
                    id="text"
                    className="p-[0.5rem] border border-gray-500 rounded-lg flex-1 outline-none col-span-4"
                    placeholder="Enter A Transaction Date"
                    disabled={true}
                  />
                </div>

                <div className="grid grid-cols-6 m-[0.3em]">
                  <label
                    htmlFor="amt-outstanding"
                    className="flex justify-start items-center col-span-2 space-x-1">
                    <span className="text-gray-700">Transaction Amount</span>
                    <span className="text-red-600 text-lg">*</span>
                  </label>
                  <input
                    value={transactionEditDetail.transaction_amount}
                    onChange={(e) =>
                      setTransactionEditDetail((prevState) => ({
                        ...prevState,
                        transaction_amount: e.target.value,
                      }))
                    }
                    type="number"
                    id="number"
                    className="p-[0.5rem] border border-gray-500 rounded-lg flex-1 outline-none col-span-4"
                    placeholder="Enter A Transaction Amount"
                  />
                </div>

                <div className="flex justify-end items-center space-x-4 mt-8 mb-4">
                  <button
                    onClick={() => setShowEditPayment(false)}
                    className="flex justify-center items-center space-x-2 bg-purple-400 text-purple-50 px-[1rem] py-[0.5rem] rounded hover:text-purple-500 hover:bg-purple-50 transition duration-[0.6s] hover:shadow-2xl hover:shadow-black">
                    <TbArrowBackUp />
                    <p>Cancel</p>
                  </button>
                  <button
                    onClick={() => editTransactionHander("edit")}
                    className="flex justify-center items-center space-x-2 bg-green-400 text-green-50 px-[1rem] py-[0.5rem] rounded hover:text-green-500 hover:bg-green-50 transition duration-[0.6s] hover:shadow-2xl hover:shadow-black ">
                    <RiSave2Fill />
                    <p>Save</p>
                  </button>
                </div>
              </div>
            </>
          )}
        </Box>
      </Modal>

      {/* search field */}
      {/* <div className='bg-white mt-[2%]'>
        <p className='bg-cyan-400 text-white px-[0.5rem] py-[1rem] '>Search Fields</p>
        <div className='px-[0.5rem] pb-[1rem] mt-2'>
          <div className='md:flex justify-start items-center '>
            <p className='w-[25rem]'>Transaction Date</p>
            <input type="date" className='outline-none border border-gray-400 rounded p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0' />
          </div>
          <div className='md:flex justify-start items-center mt-6' >
            <p className='w-[25rem]'>Agent Last Name</p>
            <input type="text" className='outline-none border border-gray-400 rounded p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0' />
          </div>
          <div className='md:flex justify-start items-center mt-6'>
            <p className='w-[25rem]'>Customer Nickname</p>
            <input type="text" className='outline-none border border-gray-400 rounded p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0' />
          </div>
          <div className='md:flex justify-start items-center mt-6'>
            <p className='w-[25rem]'>Show Cash Dispursed</p>
            <div className='mt-2 md:mt-0'>
              <input type="radio" id="Yes" />
              <label className='ml-1 mr-4' htmlFor='Yes'>Yes</label>
              <input type="radio" id="No" />
              <label className='ml-1' htmlFor='No'>No</label>
            </div>
          </div>
          <div>
            <button className='flex justify-center items-center bg-cyan-400 rounded space-x-2 px-[1rem] py-[0.5rem] mt-6 text-white' >
              <FaUndo />
              <p>Reset Search Fields</p>
            </button>

          </div>
        </div>
      </div> */}

      {/* <div className='mt-8 overflow-scroll'>
        <p className='bg-green-500 p-[1rem] md:w-[100%] w-[180%] text-white'>Total Payments Collected MYR 0</p>
        <table className='md:w-[100%] w-[180%]'>
          <thead className='h-[6vh]'>
            <tr>
              <th className='text-start'>Manager</th>
              <th className='text-start'>Agent</th>
              <th className='text-start'>Entered By</th>
              <th className='text-start'>Customer Nickname</th>
              <th className='text-start'>Loan Number</th>
              <th className='text-start'>Transaction Amount</th>
            </tr>
          </thead>
          <tbody>

          </tbody>

        </table>
        <div className='mt-6'>
          <button className='flex justify-center items-center bg-[#a3391f] rounded space-x-2 px-[1rem] py-[0.5rem] mt-6 text-white'>
            <IoExitOutline />
            <p>Exit</p>
          </button>
        </div>
      </div> */}

      <ToastContainer
        newestOnTop={false}
        rtl={false}
        transition={Flip}
        position="top-right"
        autoClose={2000}
        theme="dark"
        hideProgressBar={false}
        closeOnClick={true}
        pauseOnHover={false}
        draggable={true}
        progress={undefined}
        className="text-center"
      />
    </div>
  );
}

export default TransactionList;
